import { loadScriptOnce } from '../loaders/script'

export async function enableRoistat({ host, projectId }) {
  if (!host || !projectId) return
  if (window.roistatProjectId) return

  window.roistatProjectId = projectId
  window.roistatHost = host

  const p = location.protocol === 'https:' ? 'https://' : 'http://'
  const u = /(^|;\s*)roistat_visit=/.test(document.cookie)
    ? '/dist/module.js'
    : `/api/site/1.0/${projectId}/init?referrer=${encodeURIComponent(location.href)}`

  await loadScriptOnce(p + host + u, { id: 'roistat-loader', attrs: { charset: 'UTF-8' } })

  return true
}



// WEBPACK FOOTER //
// ./src/modules/shared/services/consent/vendors/roistat.js